import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { useLoginMutation, useDemoLoginMutation } from '@/store/api/authApi';
import { useAppDispatch } from '@/hooks/redux';
import { setTempAuthToken, setToken } from '@/store/slices/authSlice';
import { LoginFormData, loginSchema } from '@/utils/validations';
import { getPlatform } from '@/utils';
import { toast } from 'react-toastify';

export const useLoginPage = (options?: { onSuccess?: () => void }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const form = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
  });
  const { reset } = form;
  const [login, { isLoading }] = useLoginMutation();
  const [demoLogin] = useDemoLoginMutation();
  const deviceType = getPlatform();

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  // const [captchaId, setCaptchaId] = useState('');
  // const [refreshKey, setRefreshKey] = useState(0);

  //handlers
  const handleLogin = async (data: LoginFormData) => {
    try {
      const payload = {
        username: data.username,
        password: data.password,
        // captchaId,
        // captchaText: data.captcha,
        device: deviceType ?? 'Desktop',
      };

      const res = await login(payload).unwrap();

      if (!res?.passwordChanged) {
        dispatch(setTempAuthToken(res.accessToken));
        setShowChangePasswordModal(true);
        return;
      }

      if (res?.accessToken) {
        dispatch(setToken(res.accessToken));
        toast.success('Login successful!');
        reset();
        options?.onSuccess?.();
        navigate('/', { replace: true });
      }
    } catch (err: any) {
      toast.error(err?.data?.message || 'Login failed!');
    }
    // finally {
    //   setRefreshKey((prev) => prev + 1);
    // }
  };

  const handleDemoLogin = async () => {
    try {
      const res = await demoLogin().unwrap();
      if (res?.accessToken) {
        localStorage.setItem('showWelcomeBanner', 'true');
        dispatch(setToken(res.accessToken));
        toast.success('Login successful!');
        options?.onSuccess?.();
        navigate('/', { replace: true });
      }
    } catch {
      toast.error('Demo login failed');
    }
  };

  return {
    // form
    form,

    // states
    showChangePasswordModal,
    // captchaId,
    // refreshKey,
    isLoading,

    // setCaptchaId,
    setShowChangePasswordModal,

    // handlers
    handleLogin,
    handleDemoLogin,
  };
};
